(function () {
  /*
    Positions decorative gradient bands behind the "us" / "them" rows of the
    desktop comparison grid (when present). The mobile/stacked grid needs no JS.
  */
  function positionGradients(section) {
    var grid = section.querySelector('.custom-comparison-grid-desktop');
    if (!grid) return;

    var cells = Array.prototype.slice.call(grid.children);

    function getGroupCells(className) {
      return cells.filter(function (cell) {
        return cell.classList.contains(className);
      });
    }

    var firstRowCells = getGroupCells('custom-comparison-cell-corner').concat(
      getGroupCells('custom-comparison-cell-feature-header')
    );
    var secondRowCells = getGroupCells('custom-comparison-cell-us-label').concat(
      getGroupCells('custom-comparison-cell-us')
    );
    var thirdRowCells = getGroupCells('custom-comparison-cell-them-label').concat(
      getGroupCells('custom-comparison-cell-them')
    );

    var headerHeight = 0;
    var usRowTop = 0;
    var usRowHeight = 0;
    var themRowTop = 0;
    var themRowHeight = 0;

    if (firstRowCells.length) headerHeight = firstRowCells[0].offsetHeight;
    if (secondRowCells.length) {
      usRowTop = headerHeight;
      usRowHeight = secondRowCells[0].offsetHeight;
    }
    if (thirdRowCells.length) {
      themRowTop = headerHeight + usRowHeight;
      themRowHeight = thirdRowCells[0].offsetHeight;
    }

    section.style.setProperty('--ccs-us-row-top', usRowTop + 'px');
    section.style.setProperty('--ccs-us-row-height', usRowHeight + 'px');
    section.style.setProperty('--ccs-them-row-top', themRowTop + 'px');
    section.style.setProperty('--ccs-them-row-height', themRowHeight + 'px');
  }

  function initSections() {
    document.querySelectorAll('.custom-comparison-section').forEach(function (section) {
      positionGradients(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSections, 100);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSections);
    document.addEventListener('shopify:section:reorder', initSections);
  }
})();
